<template>
  <aside class="side">
    <div v-if="part !== 'status'" class="side-top">
      <p>Trusted repairs in Sahakarnagar, Bengaluru — 12+ years of technical excellence.</p>
    </div>
    <div v-if="part !== 'top'" class="side-status">
      <h3 class="mono">Service Status</h3>
      <ol class="status">
        <li v-for="(s, i) in systems" :key="s">
          <span class="n">{{ String(i + 1).padStart(2, '0') }}.</span>
          <span class="lbl">{{ s }}</span>
          <span class="dot" :class="{ on: i < lit }"></span>
        </li>
      </ol>
      <div class="binary mono">
        <span class="bar"></span>
        <div class="brows">
          <div v-for="(r, ri) in rows" :key="ri">{{ r }}</div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { gsap } from 'gsap'

export default {
  name: 'StatusRail',
  props: { part: { type: String, default: 'both' } },
  data() {
    return {
      lit: 0,
      rows: [],
      systems: [
        'DIAGNOSTICS', 'MOTHERBOARD', 'RAM & STORAGE', 'GPU / DISPLAY',
        'BATTERY & POWER', 'KEYBOARD', 'COOLING', 'DATA RECOVERY',
        'SOFTWARE / OS', 'VIRUS REMOVAL'
      ]
    }
  },
  mounted() {
    this.gen()
    this._t = setInterval(() => {
      if (this.lit < this.systems.length) this.lit++
    }, 260)
    this._b = setInterval(this.gen, 240)
    const desktop = window.matchMedia('(min-width: 901px)').matches
    const play = () => {
      gsap.fromTo(this.$el.querySelector('.side-top'),
        { yPercent: 8, opacity: 0 },
        { yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out', delay: 0.5 })
      gsap.fromTo(this.$el.querySelectorAll('.status li'),
        { opacity: 0, x: 14 },
        { opacity: 1, x: 0, duration: 0.5, stagger: 0.05, ease: 'power2.out', delay: 0.9 })
    }
    if (desktop) {
      window.addEventListener('preloader:done', play, { once: true })
      this._fallback = setTimeout(play, 6500)
    }
  },
  beforeUnmount() {
    clearInterval(this._t); clearInterval(this._b); clearTimeout(this._fallback)
  },
  methods: {
    gen() {
      const g = () => Array.from({ length: 8 }, () => Math.round(Math.random())).join('')
      this.rows = Array.from({ length: 6 }, () => `${g()}  ${g()}  ${g()}`)
    }
  }
}
</script>

<style scoped>
.side { display: flex; flex-direction: column; min-height: 100vh; background: var(--ink); }
.side-top {
  background: var(--grey);
  padding: clamp(100px, 11vw, 140px) 34px 40px;
  flex: 1 1 auto;
  display: flex; align-items: flex-end;
}
.side-top p {
  font-family: var(--font-display); font-weight: 500;
  font-size: clamp(18px, 1.5vw, 22px); line-height: 1.2; color: var(--ink);
  letter-spacing: -0.4px; margin: 0;
}
.side-status {
  background: var(--ink); color: #d0d0d4; flex: 1 1 auto;
  padding: 34px 34px 40px; overflow: visible;
}
.side-status h3 { font-size: 20px; color: #eee; margin: 0 0 22px; text-transform: none; letter-spacing: 0; font-family: var(--font-display); font-weight: 600; }
.status { list-style: none; margin: 0 0 30px; padding: 0; font-family: var(--font-mono); font-size: 12px; }
.status li { display: flex; align-items: center; gap: 8px; line-height: 2; }
.status .n { color: #6f6f75; width: 26px; }
.status .lbl { flex: 1; letter-spacing: 1px; }
.status .dot { width: 5px; height: 5px; border-radius: 50%; background: #3a3a40; transition: background 0.3s, box-shadow 0.3s; }
.status .dot.on { background: var(--coral); box-shadow: 0 0 8px var(--coral); }
.binary { display: flex; gap: 12px; font-size: 11px; color: #6f6f75; }
.bar { width: 2px; background: #4a4a50; border-radius: 2px; }
.brows div { line-height: 1.7; letter-spacing: 1px; }

@media (max-width: 900px) {
  .side { min-height: 0; }
  .side-top { flex: 0 0 auto; padding: clamp(40px, 9vw, 60px) 26px 40px; align-items: flex-start; }
  .side-status { flex: 0 0 auto; padding: 40px 26px 56px; }
}
</style>
